import React from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../features/auth/authSlice';
import { useOnClickOutside } from '../utils';
import IMG from "../images/mypic.jpg"
export default function Avatar() {
	const infoRef = useRef();
	const [showInfo, setShowInfo] = useState(false);
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth) || {};

	//logout
	const handleLogOut = () => {
		dispatch(logout());
	};

	//click-outside
	useOnClickOutside(infoRef, () => {
		setShowInfo(false);
	});

	return (
		<>
			<div className='relative'>
				<div
					className='flex items-center cursor-pointer'
					onClick={() => {
						setShowInfo(!showInfo);
					}}>
					<button className='flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer'>
						<img
							src={IMG}
							alt=''
						/>
					</button>
					<p className='ml-2'>{user?.name}</p>
				</div>
				{showInfo && (
					<div className='absolute bg-white border border-pink-600 rounded-lg py-1 px-2 right-0' ref={infoRef}>
						<ul>
							<li>{user?.email}</li>
							<li>
								<button className='font-semibold text-sm hover:text-indigo-700' onClick={handleLogOut}>
									Log out 
								</button>
							</li>
						</ul>
					</div>
				)}
			</div>
		</>
	);
}
